<div *ngIf="!equipment && !loading" class="single-equipment-page">
  <div class="title">
    <p class="vox-heading-2" translate>equipment.details.not-found</p>
  </div>
  <hr>
  <div *ngIf="errorMessage" class="vox-inline-message vox-inline-message_light-grey">
    <div class="error-text">
      <i class="icon-small-alert"></i>
      <span [innerHTML]="errorMessage | translate: {mac_address: mac_address}"></span>
    </div>
  </div>
  <button class="vox-btn vox-btn-secondary" (click)="goToEquipment()">
    <i class="icon-small-back"></i>
    <span translate>equipment.details.nav-tabs.overview.button-back</span>
  </button>
</div>
<div *ngIf="equipment && !loading" class="single-equipment-page">
  <div class="title">
    <p class="vox-heading-2">
      <i class="icon-small-arrow-left"
        [routerLink]="['../']"
        [ngbTooltip]="'equipment.details.back-to-list' | translate"
        style="cursor: pointer;">
      </i>
      {{ 'equipment.details.title' | translate:{e: equipment.mac_address, model: equipment.model} }}
    </p>
  </div>
  <hr>
  <div class="single-equipment-page__container">
    <div ngbDropdown class="vox-dropdown-input">
      <button ngbDropdownToggle>
        <span><i [ngClass]="TAB_ICONS[currentTab]"></i>{{('equipment.details.nav-tabs.' + currentTab + '.label') | translate
          }}</span>
      </button>
      <div ngbDropdownMenu>
        <button ngbDropdownItem (click)="switchTab('overview')">
          <i class="icon-small-info"></i>
          <span translate>equipment.details.nav-tabs.overview.label</span>
        </button>
        <button ngbDropdownItem (click)="switchTab('provisioning')">
          <i class="icon-small-delivery"></i>
          <span translate>equipment.details.nav-tabs.provisioning.label</span>
        </button>
      </div>
    </div>
    <ul ngbNav #nav="ngbNav" (navChange)="onNavChange($event)" [activeId]="currentTab" class="nav-pills"
      orientation="vertical">
      <li ngbNavItem="overview">
        <a ngbNavLink>
          <i class="icon-small-info"></i>
          <span translate>equipment.details.nav-tabs.overview.label</span>
        </a>
        <ng-template ngbNavContent>
          <div class="single-equipment-page__overview">
            <div class="single-equipment-page__overview-table">
              <gdp-single-equipment-table [company]="company" (changedPbx)="onDeallocatePbx($event)" [equipment]="equipment"></gdp-single-equipment-table>
            </div>
            <div class="single-equipment-page__overview-air-section">
              <gdp-single-equipment-air-section [company]="company" [equipment]="equipment" [handsetChanged]="handsetChanged" *ngIf="equipment.model === 'AIR'"></gdp-single-equipment-air-section>
            </div>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="provisioning">
        <a ngbNavLink>
          <i class="icon-small-delivery"></i>
          <span translate>equipment.details.nav-tabs.provisioning.label</span>
        </a>
        <ng-template ngbNavContent>
          <div class="single-equipment-page__provisioning">
            <gdp-single-equipment-provisioning [company]="company" [equipment]="equipment"></gdp-single-equipment-provisioning>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="single-equipment-page__tab-container"></div>
  </div>
</div>

<div *ngIf="!equipment && !errorMessage && loading" class="single-equipment-page">
  <div class="title mt-2">
    <h2><ngx-skeleton-loader [theme]="{'height': '48px', 'margin-bottom' : 0, 'margin-left': '16px'}"></ngx-skeleton-loader></h2>
  </div>
  <hr/>
  <div class="single-equipment-page__container">
    <ul class="nav-pills" style="max-width: 130px; margin-left: 20px; padding-left: 0px;">
      <ngx-skeleton-loader class="nav-item" count="2" [theme]="{'height': '80px', 'width': '100px', 'margin-left': '3px'}"></ngx-skeleton-loader>
    </ul>
    <div class="single-equipment-page__tab-container">
      <ngx-skeleton-loader class="nav-item" count="2" [theme]="{'height': '250px'}"></ngx-skeleton-loader>
    </div>
  </div>
</div>
